/* Kindly v2 — winkelwagenlade.
 * Openen/sluiten, aantallen wijzigen en toevoegen vanaf de productpagina.
 * Na elke wijziging wordt deze sectie opnieuw bij Shopify opgehaald, zodat
 * bedragen serverkant geformatteerd blijven. Alles verloopt via delegatie op
 * document, dus na het vervangen van de HTML hoeft er niets herbonden.
 */
(function () {
  'use strict';

  var OPEN = 'kv2-cart-open';

  function root() { return document.querySelector('[data-kv2-cart]'); }

  function setOpen(open) {
    document.documentElement.classList.toggle(OPEN, open);
    if (open) {
      var close = document.querySelector('.kv2-cart__close');
      if (close) close.focus({ preventScroll: true });
    }
  }

  function isOpen() { return document.documentElement.classList.contains(OPEN); }

  // Haal deze sectie opnieuw op en vervang hem, zodat prijzen en aantallen kloppen.
  function refresh() {
    var el = root();
    if (!el) return Promise.resolve();
    var id = el.getAttribute('data-section-id');
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + '?sections=' + encodeURIComponent(id)
        : '/?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (!html) return;
        var wrapper = el.closest('[id^="shopify-section-"]') || el.parentNode;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-kv2-cart]');
        if (fresh && wrapper) {
          var current = wrapper.querySelector('[data-kv2-cart]');
          if (current) current.replaceWith(fresh);
        }
        updateBubbles();
      })
      .catch(function () {});
  }

  // Tellertje in de header bijwerken.
  function updateBubbles() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.kv2-cartcount').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function () { return refresh(); });
  }

  document.addEventListener('click', function (e) {
    // Openen vanaf het winkelwagenicoon in de header.
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (cartLink && root()) {
      e.preventDefault();
      setOpen(true);
      refresh();
      return;
    }

    if (e.target.closest('[data-kv2-cart-close]')) {
      e.preventDefault();
      setOpen(false);
      return;
    }

    var qtyBtn = e.target.closest('[data-kv2-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      qtyBtn.disabled = true;
      changeLine(qtyBtn.getAttribute('data-line'), qtyBtn.getAttribute('data-qty'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) setOpen(false);
  });

  // Toevoegen vanaf de productpagina opent de lade in plaats van de winkelwagenpagina.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kv2-form]');
    if (!form || !root()) return;
    e.preventDefault();
    var btn = form.querySelector('[data-kv2-submit]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('toevoegen mislukt');
        return refresh();
      })
      .then(function () { setOpen(true); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();
